export default {
    'SITE.ROOM.AVAILABLE': 'La salle est disponible',
    'SITE.ROOM.NOT.AVAILABLE': 'Désolé la salle n\'est pas disponible à cette heure-ci',
    'SITE.ROOM.CHECK.AVAILABILITIES': 'Vérifier d\'autres disponibilités',
    'SITE.ROOM.SELECT': 'Merci de choisir une salle',
    'SITE.ROOM.BOOK': 'RÉSERVER UNE SALLE',
    'SITE.ROOM.CHOOSE.ROOM': 'Choisir une autre salle',
    'SITE.ROOM.LOADING.TEXT': 'Nous vérifions les disponibilités de la salle',
};
